module.exports = __webpack_public_path__ + "img/badge-list-thumb-014.cc0ab3d2.png";